<template lang="pug">
  div
    loyalty-dropdown-analytics(:title="$t('breadcrumb.loyalty')")
    analytics(v-if="fechaHasta && appProgram")
</template>

<script>
import LoyaltyDropDownAnalytics from '@/components/loyalty/LoyaltyDropDownAnalytics'
import Analytics from '@/components/loyalty/Analytics/Analytics'
import { mapGetters } from 'vuex'

export default {
  name: 'LoyaltyAnalytics',
  data () {
    return {
      fechaHasta: null,
      appProgram: null
    }
  },
  components: {
    'loyalty-dropdown-analytics': LoyaltyDropDownAnalytics,
    Analytics
  },
  computed: {
    ...mapGetters(['getSelectedProgram', 'getFechaHasta'])
  },
  async mounted () {
    // console.log(this.datagraf)
    this.fechaHasta = this.getFechaHasta
    this.appProgram = this.getSelectedProgram
  },
  watch: {
    async getFechaHasta (data, oldData) {
      // console.log(`LA getFechaHasta ${data} ${oldData}`)
    },
    async getSelectedProgram (data, oldData) {
      // console.log(`LA getSelectedProgram ${data} ${oldData}`)
      this.appProgram = this.getSelectedProgram
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
